// DOCUMENT READY
document.addEventListener("DOMContentLoaded", function () {
  Fancybox.bind("[data-fancybox]", {
    infinite: false,
    Carousel: false,
    Toolbar: {
      display: [
        "counter",
        "zoomIn",
        "zoomOut",
        //"slideshow",
        "fullscreen",
        "zoom",
        "close",
      ],
    },
  });

  // Scroll
  function Scroll() {
    let self = this;

    this.scrollToObject = function (objName, offset = 0) {
      let objPosition = getCoords(document.querySelector(objName)).top;

      $("body, html").animate(
        {
          scrollTop: objPosition - 60 + offset,
        },
        1000
      );
    };

    function getCoords(elem) {
      let box = elem.getBoundingClientRect();

      return {
        top: box.top + window.pageYOffset,
        right: box.right + window.pageXOffset,
        bottom: box.bottom + window.pageYOffset,
        left: box.left + window.pageXOffset,
      };
    }

    let elements = document.querySelectorAll('a[data-action="scroll"]');

    for (let el of elements) {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        let objLink = "";
        objLink = el.getAttribute("href");

        if (objLink.indexOf(".") > 0) {
          objLink = objLink.substring(1);
        }

        if (document.querySelector(objLink)) self.scrollToObject(objLink);
      });
    }
  }

  window.scroll = new Scroll();
});
